import React from 'react';

const AccountProfileHeaderDataCard = ({ children, className = "" }) => {
    return (
        <div className={`border-gray-200 dark:border-gray-800 border bg-white dark:bg-gray-900 py-4 px-[18px] rounded-2xl w-full ${className}`}>
            {children}
        </div>
    );
};

export default AccountProfileHeaderDataCard;